import joint from 'jointjs';
import { linkFactory, showLinkDropdown, initLinkDropdown } from './links';
import { initMenus, setBorderColors } from './shared/jointMenu';

const PAPER_DEFAULT_SIZE = 10000;

export function paperFactory(parentElement, graph, context, callbacks) {
  const paper = new joint.dia.Paper({
    el: parentElement,
    width: PAPER_DEFAULT_SIZE,
    height: PAPER_DEFAULT_SIZE,
    gridSize: 1,
    model: graph,
    interactive: {
      vertexAdd: false
    },
    snapLinks: {
      radius: 75
    },
    linkPinning: false,
    markAvailable: true,
    multiLinks: false,

    defaultLink: function (cellView, magnet) {
      return linkFactory(this);
    },

    validateConnection: function validateConnection(cellViewS, magnetS, cellViewT, magnetT, end, linkView) {
      // Prevent linking from input ports.
      if (magnetS && magnetS.getAttribute('port-group') === 'in') {
        return false;
      }
      // Prevent linking from output ports to input ports within one element.
      if (cellViewS === cellViewT) {
        return false;
      }
      // Prevent linking to input ports.
      return magnetT && magnetT.getAttribute('port-group') === 'in';
    },

    validateMagnet: (cellView, magnet) => {
      //Prevent multiple links from an input port
      let links = graph.getLinks();
      for (let i = 0; i < links.length; i++) {
        if ((cellView.model.id == links[i].get('source').id
          && magnet.getAttribute('port') == links[i].get('source').port)
          ||
          (cellView.model.id == links[i].get('target').id
            && magnet.getAttribute('port') == links[i].get('target').port)) {

          return false;
        }
      }
      // Disable linking interaction for magnets marked as passive (see below `.inPorts circle`).
      return magnet.getAttribute('magnet') !== 'passive';
    },

    //restrict up and left movement to the paper
    restrictTranslate: () => ({
      x: 10,
      y: 10,
      width: Number.MAX_VALUE,
      height: Number.MAX_VALUE
    }),
  });

  paper.expandToFitContent = function () {
    let minHeight = paper.options.height;
    let minWidth = paper.options.width;
    this.fitToContent({
      minWidth: minWidth,
      minHeight: minHeight
    });
  }

  //resize paper
  paper.on('cell:pointermove', function (cellView, evt, x, y) {
    paper.expandToFitContent();
  });

  var draggableBoxes = ['html.Answer', 'html.MenuItem', 'html.ListPickerAnswer', 'html.ListPickerSection',
    'html.WhatsappMessageWithButtonsButton', 'html.NewCondition', 'html.NewValueChild', 'html.WhatsappIceBreaker', 'html.UserLanguage', 'html.UserCountry'];
  var isDraggable = (cellView) => draggableBoxes.includes(cellView.model.get('type'));

  // Change answer order by drag and drop
  paper.on('cell:pointermove', function (cellView, evt, x, y) {
    if (isDraggable(cellView)) {
      getParentView(cellView).handleChildDragged(cellView);
    }
  });

  paper.on('cell:pointerup', function (cellView, evt) {
    if (isDraggable(cellView)) {
      // finalize drag and drop
      getParentView(cellView).resizeBox();
    }

    if (cellView.model.isLink() && !cellView.model.get('target').id) {   // Drop arrow on no box zone
      this.showAvailableBoxesList(cellView);
    }
  });

  //Save graph on changes
  paper.on('cell:pointerup', function (cellView, evt) {
    if (!cellView.model.isLink()) {
      callbacks.updateSerializedGraph(graph);
    }
  });



  const $timeout = angular.element(document).injector().get('$timeout');
  const $compile = angular.element(document).injector().get('$compile');
  const $rootScope = angular.element(document).injector().get('$rootScope');
  const $scope = $rootScope.$new();

  initLinkDropdown($scope, $compile);

  // Links clicking
  paper.on('cell:pointerclick', (cellView, evt, x, y) => {
    if (cellView && cellView.model.isLink() && cellView.model.get('target').id) {
      showLinkDropdown(cellView, evt, paper, $('.joint-diagram-holder'));
    }
  });

  // Links highlighting
  paper.on('cell:mouseover', function (cellView, evt) {
    if (cellView.model.isLink()) {
      cellView.model.toFront();
      cellView.sourceView.$el.find('.joint-port .port-body').addClass('diag-link-hover-port');
      cellView.targetView.$el.find('.joint-port .port-body').addClass('diag-link-hover-port');
      cellView.targetView.$el.find('.root-label').addClass('diag-link-hover-label');
    }
    // Next does not need separate hover from actionBox
    else if (cellView.model.get('type') !== 'html.Next' && cellView.model.get('type') !== 'html.HandoverItem') {
      // Change bg on hover
      cellView.$box.addClass('hover-box');
    }
  });
  paper.on('cell:mouseout', function (cellView, evt) {
    if (cellView && cellView.model.isLink()) {
      cellView.model.toBack();
      cellView.sourceView.$el.find('.joint-port .port-body').removeClass('diag-link-hover-port');
      cellView.targetView.$el.find('.joint-port .port-body').removeClass('diag-link-hover-port');
      cellView.targetView.$el.find('.root-label').removeClass('diag-link-hover-label');
    } else {
      cellView.$box.removeClass('hover-box');
    }
  });
  paper.on('link:connect', function (evt, cellView, magnet, arrowhead) {
    callbacks.updateSerializedGraph(graph);
  });



  paper.showAvailableBoxesList = (cellView) => {

    const boxesWithInPort = initMenus(context).boxesWithInPort;
    setBorderColors(boxesWithInPort);
    boxesWithInPort.forEach(e => {
      e.boxes.forEach(box => {
        box.onClick = () => paper.createAndConnectBox(box.type, cellView)
      });
    });
    $scope.availableBoxes = boxesWithInPort;

    const el = $compile('<available-boxes-menu available-boxes="availableBoxes"></available-boxes-menu>')($scope);

    $('.next-action available-boxes-menu').remove(); // Remove the previously appended menus
    $(el)
      .css({
        'top': cellView.targetPoint.y - cellView.sourcePoint.y + 'px',
        'right': - (cellView.targetPoint.x - cellView.sourcePoint.x) + 'px'
      })
      .appendTo(cellView.sourceView.$box)

    $timeout(() => {
      $(el).find('.md-icon-button').trigger('click');   // Trigger click on dropdown icon
    }, 10);

  }

  paper.createAndConnectBox = (boxType, cellView) => {

    const linkContext = {
      sourceId: cellView.sourceView.model.id
    }

    callbacks.createBox(boxType, cellView.targetPoint, linkContext);
  };

  return paper;
}

function getParentView(cellView) {
  const parent = cellView.model.getAncestors()[0];
  return cellView.paper.findViewByModel(parent);
}